// src/App.js
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./routes/Home";
import Products from "./routes/Products";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./routes/PrivateRoute";
import AdminRoute from "./routes/AdminRoute"; // Import AdminRoute
import AdminLogin from "./routes/AdminLogin";
import ProductPage from "./routes/ProductPage";
import AdminPage from "./routes/AdminPage";
import UserLogin from "./routes/UserLogin";
import UserSignup from "./routes/UserSignUp";
import AdminDashboard from "./routes/AdminDashboard"; // Import AdminDashboard
import UserAccount from "./routes/UserAccount";
import CartProvider from "./CartContext";
import Footer from "./components/Footer";
import CheckoutPage from "./routes/CheckoutPage";
import ContactPage from "./routes/ContactPage";
import SuccessPage from "./routes/SuccessPage";
import Wishlist from "./routes/Wishlist";
import MalePerfumes from "./routes/MalePerfumes";
import FemalePerfumes from "./routes/FemalePerfumes";
import UnisexPerfumes from "./routes/UnisexPerfumes";
import ProductsTable from "./components/ProductsTable";
import Orders from "./components/Orders";
import TestNav from "./routes/TestNav";
import CarGame from "./routes/TestCar";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nav" element={<TestNav />} />
            <Route path="/car" element={<CarGame />} />
            <Route path="/produktet" element={<Products />} />
            {/* <Route path="/admin" element={<AdminPage />} /> */}
            <Route path="/products/:name" element={<ProductPage />} />
            <Route path="/login" element={<UserLogin />} />
            <Route path="/signup" element={<UserSignup />} />
            <Route path="/kontakti" element={<ContactPage />} />
            <Route path="/produktet/male-perfumes" element={<MalePerfumes />} />
            <Route
              path="/produktet/female-perfumes"
              element={<FemalePerfumes />}
            />
            <Route
              path="/produktet/unisex-perfumes"
              element={<UnisexPerfumes />}
            />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/success-page" element={<SuccessPage />} />
            <Route
              path="/account"
              element={
                <PrivateRoute>
                  <UserAccount />
                </PrivateRoute>
              }
            />
            <Route
              path="/wishlist"
              element={
                <PrivateRoute>
                  <Wishlist />
                </PrivateRoute>
              }
            />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/add-product"
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/products"
              element={
                <AdminRoute>
                  <ProductsTable />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/orders"
              element={
                <AdminRoute>
                  <Orders />
                </AdminRoute>
              }
            />
          </Routes>
          <Footer />
        </div>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
